// Header search with live suggestions (CRO playbook 2.2: the search bar has to be
// visible on every page, and suggestions carry product images).
//
// Uses Shopify's predictive search endpoint, which already tolerates small typos and
// matches on title, type, vendor and tags. Synonyms are configured in the Search &
// Discovery app, not here.
(function () {
  var root = document.querySelector('[data-mdc-search-root]');
  if (!root) return;

  var panel = root.querySelector('[data-mdc-search-panel]');
  var input = root.querySelector('[data-mdc-search-input]');
  var results = root.querySelector('[data-mdc-search-results]');
  var status = root.querySelector('[data-mdc-search-status]');
  if (!panel || !input || !results) return;

  var LIMIT = 5;
  var lastQuery = '';
  var timer = null;
  var controller = null;
  var opener = null;

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' lei';
  }

  function thumb(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open(trigger) {
    if (root.classList.contains('is-open')) return;
    opener = trigger || null;
    root.classList.add('is-open');
    panel.hidden = false;
    root.querySelectorAll('[data-mdc-search-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    // The panel animates in; focusing on the next frame keeps iOS from jumping.
    requestAnimationFrame(function () {
      input.focus();
    });
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    panel.hidden = true;
    root.querySelectorAll('[data-mdc-search-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  function render(data, query) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var pages = (r.pages || []).concat(r.articles || []);
    var html = '';

    if (products.length) {
      html += '<p class="mdc-search__label">Produse</p><ul class="mdc-search__list">';
      products.forEach(function (p) {
        var img = thumb(p.featured_image && p.featured_image.url ? p.featured_image.url : p.image, 120);
        html +=
          '<li><a class="mdc-search__hit" href="' + esc(p.url) + '">' +
          (img ? '<span class="mdc-search__thumb"><img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy"></span>' : '<span class="mdc-search__thumb"></span>') +
          '<span class="mdc-search__hit-text"><span class="mdc-search__hit-title">' + esc(p.title) + '</span>' +
          (p.available ? '' : '<span class="mdc-search__hit-note">Stoc epuizat</span>') +
          '</span>' +
          '<span class="mdc-search__hit-price">' + esc(money(p.price)) + '</span></a></li>';
      });
      html += '</ul>';
    }

    if (pages.length) {
      html += '<p class="mdc-search__label">Pagini și articole</p><ul class="mdc-search__list">';
      pages.forEach(function (p) {
        html += '<li><a class="mdc-search__hit mdc-search__hit--plain" href="' + esc(p.url) + '"><span class="mdc-search__hit-title">' + esc(p.title) + '</span></a></li>';
      });
      html += '</ul>';
    }

    if (!html) {
      results.innerHTML = '<p class="mdc-search__empty">Nimic pentru „' + esc(query) + '”. Încearcă alt cuvânt.</p>';
      if (status) status.textContent = 'Niciun rezultat';
      return;
    }

    html +=
      '<a class="mdc-search__all" href="/search?q=' + encodeURIComponent(query) + '">Vezi toate rezultatele pentru „' + esc(query) + '”</a>';
    results.innerHTML = html;

    var count = products.length + pages.length;
    if (status) {
      status.textContent =
        count === 1 ? '1 rezultat' : count < 20 ? count + ' rezultate' : count + ' de rezultate';
    }
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,page,article&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data, query); })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Network trouble should never leave a spinner on screen: fall back to the
        // full search page, which works without JavaScript.
        results.innerHTML =
          '<a class="mdc-search__all" href="/search?q=' + encodeURIComponent(query) + '">Vezi rezultatele pentru „' + esc(query) + '”</a>';
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(timer);
    if (q.length < 2) {
      results.innerHTML = '';
      if (status) status.textContent = '';
      return;
    }
    timer = setTimeout(function () { search(q); }, 220);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest ? event.target.closest('[data-mdc-search-toggle]') : null;
    if (toggle) {
      event.preventDefault();
      if (root.classList.contains('is-open')) close();
      else open(toggle);
      return;
    }
    if (event.target.closest && event.target.closest('[data-mdc-search-close]')) {
      event.preventDefault();
      close();
      return;
    }
    if (root.classList.contains('is-open') && !panel.contains(event.target)) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
